// extracted by mini-css-extract-plugin
export default {"root":"I2NxvL","SolidColorMenuButtonNSkin":"ULfND1","solidColorMenuButtonNSkin":"ULfND1","linkElement":"piclkP","wrapper":"ktxcLB","label":"JghqhY"};